import UiPageListSearch from "./UiPageListSearch";
import UiPageListSearch_DynamicSearchItem from "./UiPageListSearch_DynamicSearchItem";
import { EnumUiDynamicSearchItemType } from "./EnumUiDynamicSearchItemType";
import { EnumCompare } from "./EnumCompare";

/**
 * 关联-客户公司主体关联分页列表-搜索条件分页列表-搜索条件
 * @description 自动生成的代码,请勿修改
 */
export default class DtoPageListSearchCompanyCustomerMainRelationApply extends UiPageListSearch {
    constructor() {
        //无参构造函数
        super()
    }

    [proName: string]: any;
}

/**
 * 关联-客户公司主体关联分页列表-搜索条件分页列表-搜索条件-表单校验
 */
export const DtoPageListSearchCompanyCustomerMainRelationApplyRules = {
}

/**
 * 关联-客户公司主体关联分页列表-搜索条件分页列表-搜索条件-动态搜索配置项
 */
export const DtoPageListSearchCompanyCustomerMainRelationApplyDynamicSearchItems: UiPageListSearch_DynamicSearchItem[]  = [
]
